import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-dark text-white px-4 sm:px-6 lg:px-8" data-id="element-112">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-8 text-center md:text-left" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex-shrink-0" data-id="element-114">
          <div className="w-32 h-32 rounded-full bg-gradient-to-br from-gold to-gold-light flex items-center justify-center p-1 shadow-[0_0_40px_rgba(184,146,58,0.3)] relative" data-id="element-115">
            <div className="w-full h-full rounded-full border-2 border-white/50 flex flex-col items-center justify-center bg-dark" data-id="element-116">
              <ShieldCheck className="w-10 h-10 text-gold" data-id="element-117" />
              <span className="text-gold font-bold text-xl leading-none mt-1" data-id="element-118">
                30
              </span>
              <span className="text-gold/80 text-[10px] uppercase tracking-widest" data-id="element-119">
                días
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gold mb-4" data-id="element-121">
            Garantía Ciclo en Calma de 30 días
          </h2>
          <p className="text-xl font-bold mb-4" data-id="element-122">Probá el Kit 5x5 sin riesgo.</p>
          <p className="text-gray-300 leading-relaxed mb-4" data-id="element-123">
            Si al entrar y aplicar el contenido sentís que no es claro, no es
            práctico o no te ayuda a entender mejor qué hacer antes y durante tu
            periodo, podés escribirnos dentro de los 30 días posteriores a tu
            compra y revisamos tu caso para devolverte el dinero.
          </p>
          <p className="text-gray-400 italic" data-id="element-124">
            Sin vueltas. Sin letra chica rara. Tu compra está protegida.
          </p>
        </motion.div>
      </div>
    </section>;
}